<template>
	<div>
		<header>
			<h1>Invitations</h1>
			<div v-if="$can('invitation.create')">
				<ul>
					<li><router-link
						:to="{name: 'invitations.create'}"
						class="button button--primary--small">Create Invitation</router-link></li>
				</ul>
			</div>
		</header>
		<div>
			<div class="section">
				<loader v-if="!loaded"/>
				<template v-if="loaded">
					<table-filter :filters="filters"/>
					<div v-if="!items.length" class="nothing-to-see-here">
						<p>Nothing to display.</p>
					</div>
					<table v-if="items.length" role="grid">
						<thead>
							<tr>
								<th align="left">Type</th>
								<th align="left">Service Provider Type</th>
								<th align="left">Contact Name</th>
								<th align="left">Contact Email</th>
								<th align="left">Contact Phone</th>
								<th align="center">Email Sent</th>
								<th align="center">Complete</th>
								<th align="right" class="actions"><span>Actions</span></th>
							</tr>
						</thead>
						<tfoot>
							<tr>
								<th align="left">Type</th>
								<th align="left">Service Provider Type</th>
								<th align="left">Contact Name</th>
								<th align="left">Contact Email</th>
								<th align="left">Contact Phone</th>
								<th align="center">Email Sent</th>
								<th align="center">Complete</th>
								<th align="right" class="actions"><span>Actions</span></th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="(item, itemIndex) in items" :key="itemIndex">
								<td v-html="$enum('InvitationTypesEnum').display(item.invitation_type)"/>
								<td
									v-if="$enum('InvitationTypesEnum').serviceProvider === item.invitation_type"
									v-html="$enum('ServiceProviderTypes').display(item.service_provider_type)"/>
								<td v-if="$enum('InvitationTypesEnum').serviceProvider !== item.invitation_type">—</td>
								<td v-html="item.contact_email.formatted"/>
								<td v-html="item.contact_name_first && item.contact_name_last"/>
								<td v-html="item.contact_phone"/>
								<td align="center">
									<bool-icon :value="item.email_sent"/>
								</td>
								<td align="center">
									<bool-icon :value="item.complete"/>
								</td>
								<td align="right">
									<v-contextual :processing="processing(item)">
										<v-contextual-option
											v-if="$can('update',item)"
											:route-to="{name: 'invitations.edit', params: {invitation: item.id}}">Edit</v-contextual-option>
										<v-contextual-option
											v-if="$can('view',item)"
											:route-to="{name: 'invitations.show', params: {invitation: item.id}}">View</v-contextual-option>
										<v-contextual-option
											v-if="$can('sendInvitationEmail', item)"
											@click="sendInvitationEmail(item)">Send Invitation Email</v-contextual-option>
									</v-contextual>
								</td>
							</tr>
						</tbody>
					</table>
					<paginator :links="links" :meta="meta"></paginator>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions, mapMutations} = createNamespacedHelpers("invitations");

export default {
	data() {
		return {
			processingItem: null,
		};
	},

	computed: {
		...mapState([
			"columns",
			"items",
			"links",
			"loaded",
			"meta",
			"query",
			"filters",
			"gettingModels",
		]),
	},

	methods: {
		...mapActions([
			"getModels",
			"updateModel",
			"goToPage",
			"paginate",
			"filter",
		]),
		sendInvitationEmail(invitation) {
			let self = this;
			self.processingItem = invitation;
			http().post("invitations/" + invitation.id + "/send-invitation-email").then(response => {
				self.processingItem = null;
				this.updateModel(response.data.data);
				this.$store.dispatch("alertsStore/success", "Invitation Email Sent");
			});
		},
		processing(item) {
			return this.processingItem === item;
		},
	},

	created() {
		this.getModels();
	},
};
</script>
